import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';
import { generateQuarters } from '@features/crm/utils/helpers';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

import { setIsPreserveTreeState } from '@/store/actions/crm/CRMCommonAction';

const TargetQuarterDropdown = ({ placeholder = 'Quarter', identifier = 'quarter' }) => {
	const [quarters, setQuarters] = useState([]);
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, identifier, identifier);
	const dispatch = useDispatch();

	const setDefaultFilterForTargetTab = async (obj) => {
		if (obj?.id) {
			let data = {
				name: 'quarter',
				type: 'text',
				key: obj.value,
				value: obj.quarterStartDate,
				identifier: 'quarter',
				isHideChip: true,
				isClearable: false
			};
			await dispatch(updateTextItemInGlobalFilter(data));
		}
	};

	useEffect(() => {
		const quartersList = generateQuarters();
		setQuarters(quartersList);
		if (!inputValue) {
			const thisQuarter = quartersList.find((item) => item.id === 'thisQuarter');
			setDefaultFilterForTargetTab(thisQuarter);
		}
	}, []);

	const onItemClick = (item) => {
		let data = {
			name: identifier,
			type: 'text',
			key: item.value,
			value: item.quarterStartDate,
			identifier: identifier,
			isHideChip: true,
			isClearable: false
		};
		dispatch(updateTextItemInGlobalFilter(data));
		dispatch(setIsPreserveTreeState(false));
	};

	return (
		<CustomDropdown
			type="addItem"
			title={placeholder}
			isShowLabel={false}
			onItemClick={onItemClick}
			items={quarters}
			selectedItem={inputValue?.key || placeholder}
		/>
	);
};

export default TargetQuarterDropdown;
